import { Component, Input, output } from '@angular/core';
import { LcfHistoricalRecordDto } from '../../../pages/lcf-historical/lcf-historical.service';
import { PermissionDirective } from '../../../core/permission.directive';

@Component({
	selector: 'app-calculation-history',
	imports: [PermissionDirective],
	templateUrl: './calculation-history.component.html'
})
export class CalculationHistoryComponent {
	@Input({ required: true }) calculationType!: 'FFF' | 'LCF';
	@Input({ required: true }) referenceDateLabel = '';
	@Input({ required: true }) filteredRecords: readonly LcfHistoricalRecordDto[] = [];
	@Input({ required: true }) currencies: readonly string[] = [];
	@Input() isLoading = false;
	@Input() loadError = '';

	readonly retry = output<void>();
	readonly calculationOpened = output<number | undefined>();
	readonly searchChanged = output<Event>();
	readonly currencyChanged = output<Event>();
	readonly statusChanged = output<Event>();

	formatNumber(value: number | null, maximumFractionDigits = 2): string {
		return value == null ? '—' : value.toLocaleString('en-US', { maximumFractionDigits });
	}

	formatDate(value: string | null, includeTime = false): string {
		if (!value) return '—';
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return value;
		return new Intl.DateTimeFormat('en-GB', includeTime
			? { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
			: { day: '2-digit', month: 'short', year: 'numeric' }
		).format(date);
	}
}
